import { PlanboardState } from '@reducers/v2/planboard/types';

export const clearCloseErrorAction = (state: PlanboardState) => {
  state.lastCloseError = null;
};
